import React, { useContext, useCallback } from 'react';

import { Select } from '@imgly/imgly-website-components';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';

import { getVersion } from '../../../utils/getVersion';
import { PageContext } from '../../context/PageContext';
import { pathToPreviousVersion } from '../../utils';

import * as classes from './style.module.scss';

export const VersionMenu: React.FC = () => {
  const { pathname } = useLocation();
  const {
    name,
    platform,
    versions,
    version,
    defaultVersion,
    slug,
    allSlugs,
    platforms,
  } = useContext(PageContext);

  const displayedVersion = version !== 'docs' ? version : defaultVersion;

  const handleChange = useCallback(
    (key: string) => {
      const path = pathToPreviousVersion(
        key,
        name,
        pathname,
        platform,
        version,
        slug,
        defaultVersion,
        allSlugs,
        platforms,
      );

      // remove the scroll position if the user changes to a new version
      if (typeof window !== 'undefined' && window.sessionStorage) {
        sessionStorage.removeItem('navigation-scroll-pos');
      }

      navigate(path);
    },
    [version, slug, defaultVersion],
  );

  if (
    !versions ||
    !displayedVersion ||
    (displayedVersion &&
      versions.findIndex(({ id }) => id === displayedVersion) === -1)
  ) {
    return null;
  }

  if (versions.length === 1 && defaultVersion) {
    const args = getVersion(defaultVersion, versions);
    return <div>{typeof args === 'string' ? args : args.title}</div>;
  }

  const versionArgs = getVersion(displayedVersion, versions);

  if (!versionArgs) return null;

  const options = versions.map(({ id, ...args }) => ({
    value: id,
    label: typeof args === 'string' ? args : args.title,
  }));

  return (
    <Select
      selectClassName={classes.select}
      aria-label="Switch to a different version number"
      onChange={handleChange}
      label={typeof versionArgs === 'string' ? versionArgs : versionArgs.title}
      value={typeof versionArgs === 'string' ? versionArgs : versionArgs.id}
      options={options}
    />
  );
};
